import React from 'react';
import isEqual from 'react-fast-compare';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Switch from '@material-ui/core/Switch';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import StatusIcon from 'ui/StatusIcon';

import { withPolicyStyles } from './styles';
import { ADDITIONAL_POLICY_INFO } from './constants';

class Policy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            enabled: this.props.policy.enabled,
        };
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.policy, this.props.policy)) {
            this.setState({ enabled: this.props.policy.enabled });
        }
    }

    handleExpandeChange = (event, expanded) => {
        this.setState({ expanded });
    };

    handleEnableChange = policy => () => {
        this.setState(
            (state, props) => ({ enabled: !state.enabled }),
            () => {
                if (
                    policy.policy.lookup !== 'boolean' &&
                    policy.policy.lookup !== 'backup' &&
                    this.state.enabled
                ) {
                    return;
                }
                let data = {
                    uuid: policy.uuid,
                    enabled: this.state.enabled,
                };

                const cleanValue =
                    policy.policy.lookup !== 'boolean' &&
                    policy.policy.lookup !== 'backup';
                if (!this.state.enabled && cleanValue) {
                    data['value'] = '';
                }

                this.props.onPolicyEnableChange(data);
            }
        );
    };

    renderEnableDescription = policy => {
        return this.props.renderEnableDescription ? (
            <span>
                Enabled:
                <strong style={{ paddingLeft: '5px' }}>
                    {this.props.renderEnableDescription(policy)}
                </strong>
            </span>
        ) : (
            'Enabled'
        );
    };

    renderDescription = policy => {
        return policy.enabled
            ? this.renderEnableDescription(policy)
            : 'Disabled';
    };

    render() {
        const { classes, policy, editable } = this.props;
        const additional_info =
            ADDITIONAL_POLICY_INFO[policy.policy.identifier];

        return (
            <ExpansionPanel onChange={this.handleExpandeChange}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    classes={{
                        expandIcon: classes.expandIcon,
                        content: classes.content,
                    }}
                >
                    <div className={classes.columnName}>
                        <Typography className={classes.heading}>
                            {policy.policy.name}
                        </Typography>
                        {/* <Tooltip
                            placement="right"
                            title={policy.policy.details}
                            classes={{ tooltip: classes.tooltip }}
                        >
                            <HelpIcon className={classes.help} />
                        </Tooltip> */}
                    </div>
                    <div className={classes.columnDetail}>
                        {this.state.expanded ? (
                            <div>
                                <Typography
                                    className={classes.secondaryHeading}
                                >
                                    {policy.policy.description}
                                </Typography>
                                <Typography className={classes.additionalInfo}>
                                    {additional_info &&
                                        `\n\n${additional_info}`}
                                </Typography>
                            </div>
                        ) : (
                            <div className={classes.info}>
                                <StatusIcon active={policy.enabled} />
                                <Typography
                                    className={classes.secondaryHeading}
                                >
                                    {this.renderDescription(policy)}
                                </Typography>
                            </div>
                        )}
                    </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <div className={classes.columnName} />
                    <div className={classes.columnDetail}>
                        <Switch
                            checked={this.state.enabled}
                            onChange={this.handleEnableChange(policy)}
                            disabled={!editable}
                        />
                        {this.props.renderForm && (
                            <div style={{ paddingLeft: '20px' }}>
                                {this.props.renderForm(
                                    policy,
                                    this.state.enabled
                                )}
                            </div>
                        )}
                    </div>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

export default withPolicyStyles(Policy);
